import { useTranslation } from "react-i18next";
import {
  DEFAULT_COLUMNS_LIST,
  OPTIONAL_COLUMNS_LIST,
  FROZEN_COLUMN
} from '../../../stores/UserManagement/constants';

/**
 * Create Columns array for data grid
 * @returns columns for data grid
 */
export const useGetColumns = () => {
  const { t } = useTranslation();

  return [...DEFAULT_COLUMNS_LIST, ...OPTIONAL_COLUMNS_LIST].map(
    ({ key, columnKey }) => ({
      key: key,
      columnKey,
      name: t(`userManagementPage.${key}`),
      frozen: key === FROZEN_COLUMN,
      visible: DEFAULT_COLUMNS_LIST.findIndex((it) => it.key === key) > -1,
    })
  );
};
